import React from 'react';
import {
  DIRECT_MESSAGE,
  PUBLIC_CHANNEL,
  PRIVATE_CHANNEL,
  MESSAGE,
  ATTACHMENT,
  PUBLIC_CHANNEL_LABEL,
  PRIVATE_CHANNEL_LABEL,
} from '../constants/AppConstants';
import { Hash, Lock, User, Users } from 'react-feather';
import { map, values, isNil } from 'ramda';
import { isEmpty } from 'lodash';

export const isDirectMessage = chat => chat && chat.type && chat.type === DIRECT_MESSAGE;

export const isChannel = chat => isPublicChannel(chat) || isPrivateChannel(chat);

export const isPublicChannel = chat => chat && chat.type && chat.type === PUBLIC_CHANNEL;

export const isPrivateChannel = chat => chat && chat.type && chat.type === PRIVATE_CHANNEL;

export const isGroupDirectMessage = chat => isDirectMessage(chat) && chat.users && chat.users.length > 2;

export const isSelfDirectMessage = chat => isDirectMessage(chat) && chat.users && chat.users.length === 1;

export const isOneToOneDirectMessage = chat => isDirectMessage(chat) && chat.users && chat.users.length < 3;

export const getUserIcon = (chat) => {
  if (!chat || !chat.users) return null;
  if (chat.users.length === 1) return <User size={16}/>;
  return <Users size={16}/>;
};

export const getChatIcon = (chat) => {
  if (isPrivateChannel(chat)) return <Lock size={16}/>;
  if (isGroupDirectMessage(chat)) return <Users size={16}/>;
  if (isSelfDirectMessage(chat) || isOneToOneDirectMessage(chat)) return <User size={16}/>;
  return <Hash size={16}/>;
};

export const getChatTypeName = (chat) => {
  if (isDirectMessage(chat)) return 'Direct Message';
  if (isPrivateChannel(chat)) return `${PRIVATE_CHANNEL_LABEL} Channel`;
  return `${PUBLIC_CHANNEL_LABEL} Channel`;
};

export const getSelectedMessageCount = (selectedMessages) => {
  if (isEmpty(selectedMessages)) { return 0; }
  const selectedMessageCount = isNil(selectedMessages[MESSAGE]) ? 0 : selectedMessages[MESSAGE].length;
  const selectedAttachmentCount = isNil(selectedMessages[ATTACHMENT]) ? 0 : selectedMessages[ATTACHMENT].length;
  return selectedMessageCount + selectedAttachmentCount;
};

export const formatUnreadMessageCount = unreadMessageCount => unreadMessageCount > 99 ? '99+' : unreadMessageCount;

export const isMentionedInAnyChat = chats => values(chats).some(chat => chat.userMentioned);

// returns the sum of all unread notifications in all of the chats passed in
export const calculatedTotalUnreadCount = (chats) => {
  if (chats) {
    let totalUnreadCount = 0;
    map((chat) => {
      totalUnreadCount += chat.unreadCount;
    }, chats);
    return totalUnreadCount;
  } else {
    return 0;
  }
};

export const getUnreadUnhiddenChats = chats => Object.values(chats).filter(chat => chat.unreadCount > 0 && !chat.hidden);

export const getChatElementById = chatId => document.getElementById(chatId);

export const sortChatsByTypeAndId = (chats) => {
  return chats.sort((a, b) => {
    const aIsChannel = isChannel(a);
    const bIsChannel = isChannel(a);
    if (aIsChannel && !bIsChannel) {
      return -1;
    } else if (!aIsChannel && bIsChannel) {
      return 1;
    } else {
      return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    }
  });
};

export const getChatIdByPathname = pathname => !isEmpty(pathname) && pathname.indexOf('/chat/') >= 0 ? parseInt(pathname.split('/chat/').pop(), 10) : null;
